{
  "version": 1,
  "asset_id": "60cbff2b-b50a-4306-b558-652d2f875cef",
  "project_id": "160b2239-3b67-4000-8b6e-d774982b0968",
  "url": "/__l5e/assets-v1/60cbff2b-b50a-4306-b558-652d2f875cef/dr-sara-denim-circle.jpg",
  "r2_key": "a/v1/160b2239-3b67-4000-8b6e-d774982b0968/60cbff2b-b50a-4306-b558-652d2f875cef/dr-sara-denim-circle.jpg",
  "original_filename": "dr-sara-denim-circle.jpg",
  "size": 30020,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T07:26:55Z"
}
